import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  EntidadesProductivaActividad,
  EntidadProductivaYActividades
} from '../entidades-productiva-actividad/entidades-productiva-actividad.model';

@Injectable({
  providedIn: 'root'
})
export class EntidadesProductivaActividadService {
  url: string;
  token: string;
  endpoint = 'entidadesProductivasActividad';

  constructor(private http: HttpClient) {}

  //se obtienen las actividades por los datos pasados al endpoint
  getEntidadesProductivaActividad(
    rut?: string,
    pais_codigo?: string,
    tipo_documento_codigo?: string,
    numero?: string
  ): Observable<EntidadProductivaYActividades> {
    return this.http.get<EntidadProductivaYActividades>(
      `${this.url}/${this.endpoint}/`,
      {
        params: {
          token: this.token,
          rut: rut == undefined ? '' : rut,
          pais_codigo: pais_codigo,
          tipo_documento_codigo: tipo_documento_codigo,
          numero: numero
        }
      }
    );
  }

  addEntidadProductivaActividad(
    entidadesProductivaActividad: EntidadesProductivaActividad
  ): Observable<EntidadesProductivaActividad> {
    return this.http.post<EntidadesProductivaActividad>(
      `${this.url}/${this.endpoint}/`,
      {
        ...entidadesProductivaActividad
      }
    );
  }

  changeEntidadProductivaActividad(
    p: EntidadesProductivaActividad
  ): Observable<EntidadesProductivaActividad> {
    return this.http.patch<EntidadesProductivaActividad>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        entidadesProductivaActividad: p,
        token: this.token
      }
    );
  }

  // aca va un metodo que deberia devolver una entidadproductivaactividad
  //al pasarle rut documento de persona y token
  // obtenerActividad(): Observable<EntidadProductivaYActividades> {
  //   let respuesta: EntidadProductivaYActividades;
  //   const auxActividad: Actividad = {
  //     id: 1,
  //     tipo_actividad_id: 1
  //   };
  //   const auxActividad2: Actividad = {
  //     id: 2,
  //     tipo_actividad_id: 2
  //   };

  //   respuesta.entidad_productiva_id = 1;

  //   respuesta.actividades.push(auxActividad);
  //   respuesta.actividades.push(auxActividad2);

  //   return of(respuesta);
  // }

  deleteEntidadProductivaActividad(
    p: EntidadesProductivaActividad
  ): Observable<EntidadesProductivaActividad> {
    return this.http.delete<EntidadesProductivaActividad>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }
}
